import React, { useEffect, useContext, useState } from 'react';
import ComponentProvider, { ComponentContext } from '../ComponentProvider';

export const AddedBundleCard = ({ item }) => {
  const { bundleState } = useContext(ComponentContext);
  const [bundle, setBundle] = bundleState

  const { id, product, image, variant, quantity } = item;

  const handleRemove = () => {
    const updatedBundle = bundle.filter(i => i.id != id)
    setBundle(updatedBundle)
  }

  return (
    <div className="Card Card--product Card--bundleItem" >
      <figure className='Card__figure'>
        {image &&
          <img
            src={`${image}&width=200`}
            srcSet={`${image}&width=200 200w,${image}&width=400 400w,${image}&width=600 600w`}
            loading="lazy"
            alt={product.title}
          />
        }
        <button type="button" className="Button Button--noLayout remove" onClick={handleRemove}>
          <svg className="icon" height="1em" viewBox="0 0 20 20" width="1em">
            <use href="#icon-close"></use>
          </svg>
        </button>
        <div className="Badge Badge--quantity">
          <span>{quantity}</span>
        </div>
      </figure>
      <div className='Card__details'>
        <h4 className='Card__title'>
          {product.title}
        </h4>
        {product.variants.length > 1 && product.options.map((o, index) => (
          <div className='variant-options' key={`${variant.id}-option-${index}`}>
            <dt>{o}: </dt>
            <dd>{variant.options[product.options.indexOf(o)]}</dd>
          </div>
        ))}
      </div>
    </div>
  )
}